// src/HomePage/FunLearn.js
import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { fetchStudentRewardsFirestore } from '../FirebaseService';
import './FunLearn.css';
import DailyReward from './Game/DailyReward/DailyReward';
import BibleQuiz from './Game/BibleQuiz/BibleQuiz';
import Werewolf from './Game/Werewolf/Werewolf';
import FolkGame from './Game/FolkGame/FolkGame';

const FunLearn = () => {
  const [section, setSection] = useState('reward');
  const [isCatechist, setIsCatechist] = useState(false);
  const [studentId, setStudentId] = useState('');
  const [studentInfo, setStudentInfo] = useState(null);
  const [totalStars, setTotalStars] = useState(0);
  const [hasDailyToday, setHasDailyToday] = useState(false);
  const [hasQuizToday, setHasQuizToday] = useState(false);
  const [quizAttempts, setQuizAttempts] = useState(0);

  // Tải điểm thưởng từ Firestore (Áp dụng cho cả Thiếu nhi và GLV)
  const loadRewards = async (id, isCat = isCatechist) => {
    if (!id || id === 'GLV') return;
    const rewardsData = await fetchStudentRewardsFirestore(id, isCat);
    setTotalStars(rewardsData.totalStars);
    setHasDailyToday(rewardsData.dailyToday);
    setHasQuizToday(rewardsData.hasQuizToday);
    setQuizAttempts(rewardsData.quizAttemptsToday);
  };

  // Kiểm tra đăng nhập (GLV hoặc Thiếu nhi)
  useEffect(() => {
    const isGlvLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const catechistName = localStorage.getItem('catechistFullName');
    const catechistHolyName = localStorage.getItem('catechistHolyName');
    const catechistUid = localStorage.getItem('uid');

    // ƯU TIÊN 1: Giáo Lý Viên đã đăng nhập từ Login.js
    if (isGlvLoggedIn && catechistName) {
      setIsCatechist(true);
      setStudentInfo({
        holyName: catechistHolyName || '',
        fullName: catechistName,
        isCatechist: true,
      });
      setStudentId(catechistUid || '');
      loadRewards(catechistUid, true);
      return;
    }

    // ƯU TIÊN 2: Kiểm tra thông tin Thiếu Nhi đã lưu
    setIsCatechist(false);
    const savedId = localStorage.getItem('studentId');
    const savedHolyName = localStorage.getItem('studentHolyName');
    const savedFullName = localStorage.getItem('studentFullName');

    if (savedId && savedHolyName && savedFullName) {
      setStudentInfo({
        holyName: savedHolyName,
        fullName: savedFullName,
        isCatechist: false,
      });
      setStudentId(savedId);
      loadRewards(savedId, false);
    }
  }, []);

  const handleLogout = () => {
    if (isCatechist) {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('catechistFullName');
      localStorage.removeItem('catechistHolyName');
      localStorage.removeItem('userRole');
      localStorage.removeItem('uid');
      setIsCatechist(false);
    } else {
      localStorage.removeItem('studentId');
      localStorage.removeItem('studentHolyName');
      localStorage.removeItem('studentFullName');
    }

    setStudentInfo(null);
    setStudentId('');
    setTotalStars(0);
    setHasDailyToday(false);
    setHasQuizToday(false);
    setQuizAttempts(0);
    setSection('reward');
  };

  useEffect(() => {
    const activeId = isCatechist
      ? (localStorage.getItem('uid') || studentId)
      : (localStorage.getItem('studentId') || studentId);

    if (activeId && section === 'reward') {
      loadRewards(activeId, isCatechist);
    }
  }, [section, studentId, isCatechist]);

  return (
    <div className="lgfun-wrapper">
      <Navbar />

      <div className="lgfun-blob lgfun-blob-1"></div>
      <div className="lgfun-blob lgfun-blob-2"></div>
      <div className="lgfun-blob lgfun-blob-3"></div>

      <div className="lgfun-container">
        <header className="lgfun-header-card">
          <h2 className="lgfun-main-title">✨ Vui Học Cùng Giêsu ✨</h2>
          <p className="lgfun-main-subtitle">Sân chơi tri thức & Game giải trí Thiếu Nhi</p>

          {studentInfo && (
            <div className="lgfun-user-badge">
              <button
                className="lgfun-logout-btn"
                onClick={handleLogout}
                title="Đăng xuất tài khoản"
              >
                <span>Đăng xuất</span> 🚪
              </button>

              <div className="lgfun-user-avatar">
                {isCatechist ? '✝️' : '🎓'}
              </div>
              <div className="lgfun-user-details">
                <span className="lgfun-user-greeting">
                  {isCatechist ? 'Thân chào Giáo lý viên,' : 'Thân chào Thiếu nhi,'}
                </span>
                <span className="lgfun-user-name">
                  {studentInfo.holyName} {studentInfo.fullName}
                </span>
              </div>

              <div className="lgfun-stars-pill">
                ⭐ <span className="lgfun-star-count">{totalStars}</span> Sao
                {isCatechist && <span className="lgfun-glv-tag"> (GLV)</span>}
              </div>
            </div>
          )}
        </header>

        {/* Thanh Nav Cụm Tab dạng ul li hỗ trợ cuộn ngang */}
        <nav className="lgfun-nav-tabs">
          <ul>
            <li>
              <button
                onClick={() => setSection('reward')}
                className={`lgfun-tab-btn ${section === 'reward' ? 'active' : ''}`}
              >
                🎁 Nhận Sao Mỗi Ngày
              </button>
            </li>
            <li>
              <button
                onClick={() => setSection('quiz')}
                className={`lgfun-tab-btn ${section === 'quiz' ? 'active' : ''}`}
              >
                📖 Đố Vui Kinh Thánh
              </button>
            </li>
            <li>
              <button
                onClick={() => setSection('folkgame')}
                className={`lgfun-tab-btn ${section === 'folkgame' ? 'active' : ''}`}
              >
                🎯 Trò Chơi Dân Gian
              </button>
            </li>
            <li>
              <button
                onClick={() => setSection('werewolf')}
                className={`lgfun-tab-btn ${section === 'werewolf' ? 'active' : ''}`}
              >
                🐺 Game Ma Sói
              </button>
            </li>
          </ul>
        </nav>

        {/* SECTION 1: NHẬN SAO HẰNG NGÀY */}
        {section === 'reward' && (
          <div className="lgfun-glass-section">
            <DailyReward
              studentInfo={studentInfo}
              setStudentInfo={setStudentInfo}
              studentId={studentId}
              setStudentId={setStudentId}
              isCatechist={isCatechist}
              hasDailyToday={hasDailyToday}
              hasQuizToday={hasQuizToday}
              quizAttempts={quizAttempts}
              loadRewards={loadRewards}
              onGoToQuiz={() => setSection('quiz')}
            />
          </div>
        )}

        {/* SECTION 2: BIBLE QUIZ */}
        {section === 'quiz' && (
          <div className="lgfun-glass-section">
            <BibleQuiz
              studentId={isCatechist ? localStorage.getItem('uid') : (localStorage.getItem('studentId') || studentId)}
              isCatechist={isCatechist}
              onScoreUpdate={() => loadRewards(isCatechist ? localStorage.getItem('uid') : (localStorage.getItem('studentId') || studentId), isCatechist)}
            />
          </div>
        )}

        {/* SECTION 3: GAME MA SÓI */}
        {section === 'werewolf' && (
          <div className="lgfun-glass-section">
            <Werewolf
              user={studentInfo}
              isCatechist={isCatechist}
              studentId={studentId}
            />
          </div>
        )}

        {/* SECTION 4: TRÒ CHƠI DÂN GIAN (CARO & Ô ĂN QUAN) */}
        {section === 'folkgame' && (
          <div className="lgfun-glass-section">
            <FolkGame
              user={studentInfo}
              isCatechist={isCatechist}
              studentId={studentId}
              totalStars={totalStars}
              loadRewards={loadRewards}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FunLearn;